export enum ScheduleTypeEnum {
    Planned = 1,
    OneTime = 2,
    Group = 3,
    Demo = 4,
    FreeTalk = 5,    
    PlacementPresent = 12
}